export const GET_USER_INFO = 'cv/landing/GET_USER_INFO';
export const GET_USER_INFO_FAILED = 'cv/landing/GET_USER_INFO_FAILED';
export const GET_USER_INFO_SUCCEEDED = 'cv/landing/GET_USER_INFO_SUCCEEDED';
